import type { LocalStorageKey } from '~/models/local-storage-key'

/**
 * To remove a value from localStorage, assign null to the returned ref value
 */
export function useLocalStorage<T>(key: LocalStorageKey) {
  if (process.server) {
    throw new Error("Don't use local storage on server side")
  }

  const rawItem = window.localStorage.getItem(key)

  const value = ref<T | null>(rawItem ? JSON.parse(rawItem) : null)

  watch(
    value,
    (newValue) => {
      if (newValue === null) {
        window.localStorage.removeItem(key)
      } else {
        window.localStorage.setItem(key, JSON.stringify(newValue))
      }
    },
    { deep: true, flush: 'sync' }
  )

  return value
}
